//      

export default function useDev(useHook            ) {
  // Don't run any validation in production
  if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useHook();
  }
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-dev.js